import { useState } from "react";

/**
 * Leetify's official "Data Provided by Leetify" logo, linked to leetify.com,
 * as its API developer guidelines require wherever its data shows. The app is
 * dark, so this is the primary (white and pink) version. The file comes from
 * Leetify's logo pack (see deploy/README.md): until it is in public/leetify/,
 * the words stand in, which the guidelines also allow.
 */
const LOGOS = ["/leetify/data-provided-by-leetify.svg", "/leetify/data-provided-by-leetify.png"];

export function LeetifyCredit() {
  const [i, setI] = useState(0);
  return (
    <a className="leetify-credit" href="https://leetify.com/" target="_blank" rel="noreferrer">
      {i < LOGOS.length ? <img src={LOGOS[i]} alt="Data Provided by Leetify" height={22} onError={() => setI(i + 1)} /> : "Data Provided by Leetify"}
    </a>
  );
}

/** The guidelines' wording for a link back to a player's data on Leetify. */
export function ViewOnLeetify({ url }: { url: string }) {
  return (
    <a className="view-on-leetify" href={url} target="_blank" rel="noreferrer">
      View on Leetify
    </a>
  );
}
